import styled from "@emotion/styled";
import { Card, Col, Modal, Row, Typography } from "antd";
import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfilesHeader from "./ProfileHeader";
import CardMenuProfile from "./CardMenuProfile";
import {
  bookBank,
  call,
  email,
  facebook,
  guardKey,
  memuContact,
  memuHelp,
  memuHistory,
  memuSetting,
  menuCampaign,
  menuPeple,
  menuProduct,
  menuReport,
  walletIncom,
} from "assets/icons";

const Profiles: FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const sectionOne = [
    {
      title: "จัดการสินค้า",
      icon: menuProduct,
      func: () => {
        navigate("/manage-product");
      },
    },
    {
      title: "รายงาน/แดชบอร์ด",
      icon: menuReport,
      func: () => {
        navigate("/dashboard");
      },
    },
  ];

  const sectionTwo = [
    {
      title: "ตัวแทนของฉัน",
      icon: menuPeple,
      func: () => {
        navigate("/manage-agent");
      },
    },
    {
      title: "ประวัติการสั่งซื้อ",
      icon: memuHistory,
      func: () => {
        navigate("/order");
      },
    },
  ];

  const sectionThree = [
    {
      title: "ตั้งค่าบัญชีผู้ใช้",
      icon: memuSetting,
      func: () => {
        navigate("/profiles/profile-setting");
      },
    },
    {
      title: "ผู้ใช้งานระบบ",
      icon: guardKey,
      func: () => {
        navigate("/profiles/user-system");
      },
    },
    // {
    //   title: "ติดต่อลุงอเนก",
    //   icon: memuContact,
    //   func: () => {
    //     showModal();
    //   },
    // },
  ];

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <ColumnWrapper>
              <AgentsCardWrapper>
                <ProfilesHeader />
              </AgentsCardWrapper>
            </ColumnWrapper>
            <WrapperAll>
              <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionOne.map((item, index) => {
                  return (
                    <CardMenuProfile
                      key={index}
                      title={item.title}
                      icon={item.icon}
                      func={item.func}
                    />
                  );
                })}
              </Row>

              <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionTwo.map((item, index) => {
                  return (
                    <CardMenuProfile
                      key={index}
                      title={item.title}
                      icon={item.icon}
                      func={item.func}
                    />
                  );
                })}
              </Row>

              <Row
                gutter={[8, 0]}
                style={{
                  backgroundColor: "#EFEFEF",
                  overflow: "auto",
                  padding: "10px 0px 0px 0px",
                }}
              >
                {sectionThree.map((item, index) => {
                  return (
                    <CardMenuProfile
                      key={index}
                      title={item.title}
                      icon={item.icon}
                      func={item.func}
                    />
                  );
                })}
              </Row>
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <Modal
        title="ติดต่อลุงอเนก"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
      >
        <WrapperTextModal>
          <span style={{ marginRight: 10 }}>{call}</span>
          <Typography.Text></Typography.Text>
        </WrapperTextModal>
        <WrapperTextModal>
          <span style={{ marginRight: 10 }}>{email}</span>
          <Typography.Text></Typography.Text>
        </WrapperTextModal>
        <WrapperTextModal>
          <span style={{ marginRight: 10 }}>{facebook}</span>
          <Typography.Text>ลุงอเนก</Typography.Text>
        </WrapperTextModal>
      </Modal>
    </>
  );
};

export default Profiles;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AgentsCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;

const WrapperTextModal = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0px;
`;
